import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { ArrowDownTrayIcon, DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import { auth } from "../lib/firebase";
import { safeStorage, safeSessionStorage } from "../utils/storage";
import { useLanguage } from "../contexts/LanguageContext";
import Logo from "./Logo";

// Shown instead of the dashboard to someone whose every store membership is
// scanner-only (store_users.dashboard_access = false). They signed in with a
// valid account, so this is not an auth error — they are in the wrong app.
// Rendered outside Layout, so it carries its own sign-out.
export default function ScannerOnlyNotice() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      safeStorage.clear();
      safeSessionStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <Logo className="mb-8" />
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-sm ring-1 ring-gray-900/5 space-y-4">
        <DevicePhoneMobileIcon className="mx-auto h-12 w-12 text-gray-400" aria-hidden="true" />
        <h1 className="text-lg font-semibold text-gray-900">{t("scannerOnly.title")}</h1>
        <p className="text-sm text-gray-500">{t("scannerOnly.description")}</p>
        <a
          href="https://download.loyaltify.io"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500"
        >
          <ArrowDownTrayIcon className="h-5 w-5" aria-hidden="true" />
          {t("nav.downloadScannerApp")}
        </a>
        <div>
          <button
            type="button"
            onClick={handleLogout}
            className="text-sm font-medium text-gray-500 hover:text-gray-700"
          >
            {t("nav.signOut")}
          </button>
        </div>
      </div>
    </div>
  );
}
